import { ReactElement } from 'react';
import { ErrorOutlineOutlined } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';

interface InfoRowProps {
  title: string;
  content?: string | ReactElement;
}

const CardInfos = ({
  rows,
  onClick,
  buttonIdentification,
  hiddenButton = false,
}: {
  rows: InfoRowProps[];
  onClick: () => void;
  buttonIdentification: string;
  hiddenButton?: boolean;
}) => {
  const stringToKebabCase = (s: string) => s.toLowerCase().replace(' ', '-');
  return (
    <Box
      sx={{
        borderRadius: '12px',
        padding: '14px 16px',
        backgroundColor: 'background.paper',
        marginBottom: '16px',
      }}
    >
      {rows.map(({ title, content }) => (
        <Box
          key={`title-${title}`}
          component="span"
          sx={{
            width: '100%',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            textAlign: 'right',
          }}
        >
          <Typography
            variant="caption"
            sx={{ opacity: '50%', whiteSpace: 'nowrap' }}
          >
            {title}
          </Typography>

          <Typography
            variant="body2"
            data-testid={`${stringToKebabCase(title)}-content`}
          >
            {content || <ErrorOutlineOutlined sx={{ color: 'warning.main' }} />}
          </Typography>
        </Box>
      ))}
      {!hiddenButton && (
        <Button
          data-testid={buttonIdentification}
          onClick={onClick}
          sx={{ marginLeft: 'auto', display: 'flex', marginTop: '16px' }}
        >
          Editar
        </Button>
      )}
    </Box>
  );
};

export default CardInfos;
